/* eslint-disable no-underscore-dangle */
import { useCallback, useMemo } from 'react';

import { Stack } from '@mui/material';

import { TableConfig } from 'types/builder/componentConfig';

import { RichTextEditor } from './RichTextEditor';

type TableControlProps = {
    node?: TableConfig;
    onChange: (node?: TableConfig) => void;
};

export const TableControl = ({
    node,
    onChange,
}: TableControlProps): JSX.Element => {
    const onTableChange = useCallback(
        (table: string) => {
            onChange({
                component: 'table',
                props: {
                    ...node?.props,
                    children: table,
                },
            });
        },
        [node?.props, onChange]
    );

    const { children } = useMemo(() => node?.props || {}, [node?.props]);

    return (
        <Stack spacing={2}>
            <RichTextEditor
                value={children ? String(children) : ''}
                onChange={onTableChange}
                key="table"
            />
        </Stack>
    );
};
